import "./mycandidates.scss";
import "styles/sharedStyles/subMenuBtns.scss";

import СandidatesMap from "./СandidatesMap/index";
import Applications from "./Applications/index";
import { useEffect, useState } from "react";
import { inject, observer } from "mobx-react";
import { useNavigate } from "react-router-dom";
// import BillingPeriod from "./BillingPeriod";

const MyCandidates = ({
  token,
  getUserData,
  candidates,
  cleanCandidates,
  // getApplications,
  cleanApplications,
  getSettings,
  getVacanciesData,
  cleanFilesSuccess,
  setCandidateSurname,
  // applicationAcceptedId,

  // setPrevRes,
  // setSort,
  // setSorted,
  setFilter
}) => {
  const [isLoading, setisLoading] = useState(false);
  const [isSelected, setIsSelected] = useState("Мои кандидаты");
  const navigate = useNavigate();

  useEffect(() => {
    setisLoading(true);
    getSettings();
    cleanApplications();
    cleanCandidates();
    setCandidateSurname("");

    getUserData({ newToken: token });

    getVacanciesData("1000");
    cleanFilesSuccess();
    setisLoading(false);
  }, []);

  useEffect(() => {
    if (!token) {
      setTimeout(() => {
        navigate(`/allvacancies`);
      }, 500);
    }
  }, [token]);

  const openCandidatesList = () => {
    setIsSelected("Мои кандидаты");
  };

  const openApplications = () => {
    setFilter("applicationsStatuses", []);
    cleanApplications();
    setCandidateSurname("");
    setIsSelected("Отклики");
  };

  // const openBillingPeriod = () => {
  //   cleanApplications();

  //   setFilter("vacancies", []);
  //   setFilter("education_centers", []);
  //   setFilter("applicationsStatuses", [applicationAcceptedId]);

  //   setPrevRes(1);

  //   setSort("date_create");
  //   setSorted("desc");

  //   getApplications();
  //   setIsSelected("Расчетный период");
  // };

  return (
    <div className="candidates-wrapper">
      <div className="candidates">
        <div className="submenu-btns">
          <p
            className={`submenu-btn ${
              isSelected === "Мои кандидаты" ? "submenu-btn_selected" : ""
            }`}
            onClick={() => openCandidatesList()}
          >
            Мои кандидаты
          </p>
          <p
            className={`submenu-btn ${
              isSelected === "Отклики" ? "submenu-btn_selected" : ""
            }`}
            onClick={() => openApplications()}
          >
            Отклики
          </p>
          {/* <p
            className={`submenu-btn ${
              isSelected === "Расчетный период" ? "submenu-btn_selected" : ""
            }`}
            onClick={() => openBillingPeriod()}
          >
            Расчетный период
          </p> */}
        </div>

        <div>
          {!isLoading ? (
            <>
              {isSelected === "Отклики" && <Applications />}
              {isSelected === "Мои кандидаты" && (
                <СandidatesMap isLoading={isLoading} candidates={candidates} />
              )}
              {/* {isSelected === "Расчетный период" && <BillingPeriod />} */}
            </>
          ) : (
            "Пожалуйста, подождите"
          )}
        </div>
      </div>
    </div>
  );
};

export default inject(
  ({ usersStore, candidatesStore, vacanciesStore, filesStore }) => {
    const { token, userData, getUserData } = usersStore;

    const { cleanFilesSuccess } = filesStore;

    const { vacancies, getVacanciesData } = vacanciesStore;
    const {
      candidates,
      cleanCandidates,
      getApplications,
      cleanApplications,
      setCandidateSurname,
      getSettings,
      setFilter,
      applicationAcceptedId,
      setPrevRes,
      setSort,
      setSorted
    } = candidatesStore;
    return {
      token,
      userData,
      getUserData,
      candidates,
      cleanCandidates,

      getApplications,
      getSettings,
      cleanApplications,
      setCandidateSurname,
      vacancies,
      getVacanciesData,
      cleanFilesSuccess,

      applicationAcceptedId,

      setPrevRes,
      setSort,
      setSorted,
      setFilter
    };
  }
)(observer(MyCandidates));
